module.exports = __webpack_public_path__ + "img/nav-back.2fe3b5de.svg";